import { useState, useEffect, useCallback } from "react";
import { getStorageQuota } from "@/features/files/services/sharepointService";
import type { StorageQuota } from "@/features/files/types/sharepoint";

/** Consistent byte-to-GB conversion used across all platforms. */
export const bytesToGB = (bytes: number): number => bytes / (1024 * 1024 * 1024);

export function useStorageQuota() {
  const [quota, setQuota] = useState<StorageQuota | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    setLoading(true);
    getStorageQuota()
      .then(setQuota)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { quota, quotaLoading: loading, refreshQuota: refresh };
}
